import { NumericFormat } from 'react-number-format';
import { Input } from '@/components/ui/input.jsx';

// Whole-dollar currency input. State holds the raw number (or '' when empty);
// display formats with thousands separators + a "$ " prefix. onValueChange
// receives react-number-format's values object — destructure { floatValue }
// (undefined when the field is cleared).
export function MoneyInput({ value, onValueChange, className, placeholder, disabled, id, name }) {
  return (
    <NumericFormat
      customInput={Input}
      value={value == null || value === '' ? '' : value}
      onValueChange={onValueChange}
      thousandSeparator=","
      decimalSeparator="."
      prefix="$ "
      decimalScale={0}
      allowNegative={false}
      className={className}
      placeholder={placeholder}
      disabled={disabled}
      id={id}
      name={name}
    />
  );
}
